import useXoltarNavigation from "../../hooks/useXoltarNav";
import { useCoreAvailability } from "../../hooks/validateCores";
import { useWebValidation } from "../../hooks/websiteValidatioHook";
import BaseCardView from "../../Components/BaseCardView/BaseCardView";

function Intro() {
  useWebValidation();
  const navigate = useXoltarNavigation();
  useCoreAvailability();
  return (
    <BaseCardView
      data-testid="Intro"
      pageName="Intro"
      dynamicLoad
      disablePrevious
      hidePrev
      bodyComponent={(body: string) => (
        <span>
          {body.split("\n").map((value, index) => (
            <div key={`${Date.now()}-${index}`}>
              {value}
              <br />
            </div>
          ))}
        </span>
      )}
      onNext={() => {
        navigate("Policy");
      }}
    />
  );
}
export default Intro;
